import gql from 'graphql-tag';

/** Client side query returns the collection of alerts */
export const GetAlertsQuery = gql`
    query GetAlerts {
        alerts @client {
            id
            message
            color
            count
        }
    }
`;

/** Client side mutation adds an alert to the alerts collection */
export const AddAlertMutation = gql`
    mutation AddAlertMutation($message: String!, $color: String) {
        addAlert(message: $message, color: $color) @client {
            alerts @client {
                id
                message
                color
                count
            }
        }
    }
`;

/** Client side mutation removes alerts from the alerts collection */
export const RemoveAlertMutation = gql`
    mutation RemoveAlertMutation($message: String!) {
        removeAlert(message: $message) @client {
            alerts @client {
                id
                message
                color
                count
            }
        }
    }
`;

/** Client side mutation clears the alerts collection */
export const ClearAlertsMutation = gql`
    mutation ClearAlerts {
        clearAlerts @client
    }
`;



// WEBPACK FOOTER //
// ./src/client/clientState/alerts/queries.ts